import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

// KSK2101_R01 전용 DTO (백엔드 KSK2101_R01RowDto 매핑)
export interface KSK2101_R01Dto extends ProductWorkDto {
	
	itemSpec: string;
	itemUnit: string;

	workprocess: string;

}

export const defaultKSK2101_R01Dto: KSK2101_R01Dto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

	productWorkNo: '',
	productWorkNm: '',
	compCd: '',
	compNm: '',
	workDt: formatDate(new Date()),
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	orderQty: 0,
	workEmp: '',
	workEmpNm: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",
	remark: '',

	itemSpec: '',
	itemUnit: '',

	workprocess: '',

    inserted: false,
    isModified: false,
};

